export const formatBytes = (bytes) => {
  if (bytes === null || bytes === undefined || !Number.isFinite(Number(bytes)))
    return "Not measured";
  const n = Number(bytes);
  const units = ["B", "KiB", "MiB", "GiB", "TiB"];
  const i = n > 0 ? Math.min(4, Math.floor(Math.log(n) / Math.log(1024))) : 0;
  return `${(n / 1024 ** i).toLocaleString(undefined, { maximumFractionDigits: i ? 1 : 0 })} ${units[i]}`;
};
export const fieldValue = (value, unit = "") =>
  value === undefined || value === null || value === ""
    ? "Not reported"
    : typeof value === "boolean"
      ? value
        ? "Yes"
        : "No"
      : `${typeof value === "number" ? value.toLocaleString(undefined, { maximumFractionDigits: 3 }) : value}${unit ? ` ${unit}` : ""}`;
export const fieldTime = (value) =>
  value && !Number.isNaN(new Date(value).getTime())
    ? new Intl.DateTimeFormat("en-SG", {
        timeZone: "Asia/Singapore",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }).format(new Date(value))
    : "No timestamp";
// "45 s", "12 min", "1 h 30 min", "2 h".
export const duration = (seconds) => {
  const s = Math.max(0, Math.round(seconds));
  if (s < 90) return `${s} s`;
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min`;
  return m % 60 ? `${Math.floor(m / 60)} h ${m % 60} min` : `${m / 60} h`;
};
export const OCTOBER_START = Date.parse("2026-10-01T00:00:00+08:00");
export function eligibleCaptures(rows) {
  return (rows || [])
    .filter(
      (r) =>
        Number.isFinite(Date.parse(r.captured_at)) &&
        Date.parse(r.captured_at) >= OCTOBER_START,
    )
    .sort((a, b) => Date.parse(a.captured_at) - Date.parse(b.captured_at));
}
export const defaultCalibration = () => ({
  cameras: {
    A: {
      center_x: 0.5,
      center_y: 0.5,
      radius: 0.5,
      fov_deg: 190,
      roll_deg: 0,
      yaw_deg: 0,
      flip_x: false,
      flip_y: false,
    },
    B: {
      center_x: 0.5,
      center_y: 0.5,
      radius: 0.5,
      fov_deg: 190,
      roll_deg: 0,
      yaw_deg: 180,
      flip_x: false,
      flip_y: false,
    },
  },
  heading_deg: 0,
  seam_deg: 0,
});

export function calibrationForIdentities(identities = ["A", "B"]) {
  const d = defaultCalibration();
  return {
    ...d,
    cameras: Object.fromEntries(
      identities.map((id, i) => [id, { ...d.cameras[i === 0 ? "A" : "B"] }]),
    ),
  };
}
export function cleanCalibration(value) {
  return {
    revision: value.revision,
    cameras: value.cameras,
    heading_deg: value.heading_deg,
    seam_deg: value.seam_deg,
  };
}

// Settings requests: poll quickly while one is on its way to the node. An
// "acknowledged" request usually turns "confirmed" within minutes, but some
// never do (cancels, a read-back that differs), so it only keeps the fast
// refresh for a while after its last update.
const FAST_REFRESH_STATES = ["queued", "sent", "pending"];
export const ACKNOWLEDGED_FAST_REFRESH_MS = 10 * 60 * 1000;
export function needsFastRefresh(settings, now = Date.now()) {
  const status = settings?.status;
  if (FAST_REFRESH_STATES.includes(status)) return true;
  if (status !== "acknowledged") return false;
  const updated = Date.parse(settings?.updated_at);
  return Number.isFinite(updated) && now - updated < ACKNOWLEDGED_FAST_REFRESH_MS;
}
